class CustomSelect extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Get the container and items
    const itemsContainer = this.querySelector('.link-list__items');
    const defaultNav = this.querySelector('.link-list__nav--default');
    const dropdownNav = this.querySelector('.link-list__nav--dropdown');
    const dropdownTitle = this.querySelector('.link-list__mobile-dropdown-text');

    if (!itemsContainer || !defaultNav || !dropdownNav) {
      console.error('CustomSelect: Required elements not found');
      return;
    }

    // Get all child blocks (links and buttons)
    const items = Array.from(itemsContainer.children).filter(
      (el) => el.classList.contains('shopify-block')
    );

    if (items.length === 0) {
      console.warn('CustomSelect: No child blocks found');
      return;
    }

    // Set the dropdown title to the first item's text
    if (dropdownTitle && items.length > 0) {
      dropdownTitle.textContent = items[0].textContent.trim();
    }

    // Populate both navigations
    items.forEach((item, index) => {
      const navItem = this.createNavItem(item, index);
      defaultNav.appendChild(navItem.cloneNode(true));

      if (dropdownNav) {
        dropdownNav.appendChild(navItem);
      }
    });


    // Set up keyboard navigation
    this.setupKeyboardNavigation();
  }

  createNavItem(item, index) {
    const navItem = document.createElement('div');
    navItem.className = 'link-list__nav-item';

    // Clone the original button/link element to preserve all classes and CSS variables
    const clonedItem = item.cloneNode(true);

    // Update the class to be a navigation link
    clonedItem.classList.add('link-list__link');
    clonedItem.setAttribute('data-index', index);

    // Handle dropdown closing and title update on click
    clonedItem.addEventListener('click', () => {
      const dropdown = this.querySelector('.link-list__mobile-dropdown');
      const dropdownTitle = this.querySelector('.link-list__mobile-dropdown-text');

      if (dropdown && dropdown.hasAttribute('open')) {
        dropdown.removeAttribute('open');

        // Update the dropdown title to the selected item's text
        if (dropdownTitle) {
          dropdownTitle.textContent = clonedItem.textContent.trim();
        }
      }
    });

    navItem.appendChild(clonedItem);
    return navItem;
  }

  setupKeyboardNavigation() {
    const links = this.querySelectorAll('.link-list__link');

    links.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        let targetIndex = index;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          targetIndex = (index + 1) % links.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          targetIndex = (index - 1 + links.length) % links.length;
        } else if (e.key === 'Home') {
          e.preventDefault();
          targetIndex = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          targetIndex = links.length - 1;
        }

        if (targetIndex !== index) {
          links[targetIndex].focus();
        }
      });
    });
  }
}

customElements.define('custom-select', CustomSelect);
